export default function AuthenticationLoadingPlaceholder({
  reserveLoginCardSpace = false,
}: {
  reserveLoginCardSpace?: boolean;
}) {
  return (
    <main aria-busy="true" aria-label="Loading sign in" className="auth-page" role="status">
      <section
        className={`auth-card auth-entry-loading__card${reserveLoginCardSpace ? ' auth-card--login' : ''}`}
      >
        <div className="auth-logo">
          <h1>Sign in</h1>
        </div>
        <span className="auth-entry-loading__field" />
        <span className="auth-entry-loading__field" />
        <span className="auth-entry-loading__remember" />
        <span className="auth-entry-loading__button" />
      </section>
    </main>
  );
}
